var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"beforeClose":_vm.beforeClose,"visible":_vm.visible,"cancelDialog":_vm.cancelDialog,"confirmDialog":_vm.confirmDialog}},[_c('p',[_vm._v("有凭证、期初数据或存在结账期间，无法再修改账套启用年月。因为已经有数据记录，则不能再修改账套启用期间")])])
}
var staticRenderFns = []

export { render, staticRenderFns }